import React, { useEffect, useState } from 'react';

import { Search as SearchIcon } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppAction } from 'src/actions/app.action';
import { NewdanhmucsanphamAction } from 'src/actions/newdanhmucsanpham.action';
import * as XLSX from 'xlsx';

import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  SIM_TYPE_LIST,
  SIM_TYPE_LIST_OBJ,
  SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
  Select as Select1,
  MenuItem,
} from '@material-ui/core';

import Select from 'react-select';

import CreateEditDialog from './CreateEditDialog';
import ErrorDialog from './ErrorDialog';

import { saveAs } from 'file-saver';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Settings, Download, Upload, Cached, ReportProblem } from '@material-ui/icons';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { isGrantPermission } from 'src/utils/utils';

const NewdanhmucsanphamToolbar = (props) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [preview, setPreview] = useState(false);
  const [assign, setAssign] = useState(false);
  const { isLoading } = useSelector(state => state.app);
  const { info, permissions, role } = useSelector(state => state.profile);
  const { errorRows } = useSelector(state => state.newdanhmucsanpham);

  const danhSachLoaiSim = SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR;

  const fileInput = React.useRef();

  useEffect(() => {
    if (errorRows) {
      console.log("errorRows", errorRows, Object.entries(errorRows).length, Object.values(errorRows).length, Object.keys(errorRows).length);
    }
  }, [errorRows])

  const handleClickOpenErrorDialog = () => {
    setOpenErrorDialog(true);
  };

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClosePreview = () => {
    fileInput.current.value = null;
    setPreview(false)
  }

  const handleCloseAssign = () => {
    fileInput.current.value = null;
    setAssign(false)
  }

  const handleOpenAssign = () => {
    dispatch(NewdanhmucsanphamAction.countAssign())
    setAssign(true)
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const today = new Date();

    const payload = {
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
      ma: "",
      ten: "",
    };
    dispatch(NewdanhmucsanphamAction.updateFilter(payload));
  }, []);

  const onLookup = () => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      ma: values.ma,
      ten: values.ten,
    };
    dispatch(NewdanhmucsanphamAction.updateFilter(payload));
    dispatch(NewdanhmucsanphamAction.list())
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const [values, setValues] = useState({
    ma: "",
    ten: "",
  });

  const handleImportFile = (e) => {
    e.preventDefault();
    dispatch(AppAction.appLoading(true))
    const files = e.target.files, f = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      let readedData = XLSX.read(data, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      /* Convert array to json*/
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const headerRow = dataParse[0]; // đây là dòng tiêu đề
      const dataRows = dataParse.slice(1); // phần dữ liệu thực sự (bỏ tiêu đề)
      const temp = dataRows
      .filter(c => c[0] !== undefined && c[2] !== undefined && c[0] !== null && c[2] !== null && c[0].toString().trim() !== '' && c[2].toString().trim() !== '')
      .map((c) => ({
        ten_file_upload: files[0].name,
        ma: c[0],
        ten: c[1],
        number_type: c[2].toUpperCase() == 'TRẢ TRƯỚC' ? '1' : (c[2].toUpperCase() == 'TRẢ SAU' ? '2' : ''),
        gia_goc: c[3],
        gia_si_1: c[4],
        gia_si_2: c[5],
        gia_si_3: c[6],
        gia_khach_hang: c[7],
        gia_khach_hang_khuyen_mai: c[8],
        loai_sim: c[9],
        ghi_chu: c[10],
        trang_thai: c[11],
        nguon_nhap: c[12],
      }));
      let temp1 = {}
      if (temp != null && temp.length > 0) {
        let i = 0
        temp.forEach(function (element) {
          temp1[element.ma] = element
          i++;
        })
      }
      temp1 = Object.values(temp1)
      console.log(temp1);
      dispatch(NewdanhmucsanphamAction.saveDataUpload(temp1));
    };
    reader.readAsBinaryString(f)
  }

  const exportExcel = async () => {
    dispatch(AppAction.appLoading(true))
    try {
      const payload = {
        page: 0,
        limit: 9999999999,
        ma: values.ma,
        ten: values.ten,
      };
      dispatch(NewdanhmucsanphamAction.updateFilter(payload));
      const response = await dispatch(NewdanhmucsanphamAction.list());

      let data = [];
      let data1 = [];

      if (danhSachLoaiSim && Object.keys(danhSachLoaiSim).length > 0) {
        Object.entries(danhSachLoaiSim).forEach(([key, value]) => {
          data1.push([
            key,
            value,
          ])
        });
      }

      let titleLine = [];
      
      titleLine.push('Số điện thoại');
      titleLine.push('Nhà mạng');
      titleLine.push('Loại thuê bao');

      if (isGrantPermission(permissions, ["newdanhmucsanpham.giagoc"])) {
        titleLine.push('Giá gốc');
      }

      if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi1"])) {
        if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi2"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giasi3"])) {
          titleLine.push('Giá sỉ 1');
        } else {
          titleLine.push('Giá');
        }
      }

      if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi2"])) {
        if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giasi3"])) {
          titleLine.push('Giá sỉ 2');
        } else {
          titleLine.push('Giá');
        }
      }

      if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi3"])) {
        if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giasi2"])) {
          titleLine.push('Giá sỉ 3');
        } else {
          titleLine.push('Giá');
        }
      }

      if (isGrantPermission(permissions, ["newdanhmucsanpham.giakhachhang"])) {
        titleLine.push('Giá khách hàng');
        titleLine.push('Giá khách hàng khuyến mãi');
      }

      titleLine.push('Loại sim');
      titleLine.push('Ghi chú');
      titleLine.push('Trạng thái');

      if (role.priority < 4) {
        titleLine.push('Nguồn nhập');
      }

      data = [
        titleLine,
      ];

      if (typeof response !== 'undefined' && response != null && typeof response.data !== 'undefined' && response.data != null && typeof response.data.values !== 'undefined' && response.data.values != null && response.data.values.length > 0) {
        let count = 1;
        response.data.values.forEach((element) => {
          let loaiSim = [];

          if (element.types && Object.keys(element.types).length > 0) {
              Object.entries(element.types).forEach(([key, value]) => {
                if (value.loai_sim && value.loai_sim.trim() !== "") loaiSim.push(value.loai_sim);
              });
          }

          let dataLine = [];

          dataLine.push(element.ma_co_dau_cham);
          dataLine.push(element.ten);
          dataLine.push(element.number_type == 1 ? 'TRẢ TRƯỚC' : (element.number_type == 2 ? 'TRẢ SAU' : ''));

          if (isGrantPermission(permissions, ["newdanhmucsanpham.giagoc"])) {
            dataLine.push(element.gia_goc);
          }
    
          if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi1"])) {
            dataLine.push(element.gia_si_1);
          }
    
          if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi2"])) {
            dataLine.push(element.gia_si_2);
          }
    
          if (isGrantPermission(permissions, ["newdanhmucsanpham.giasi3"])) {
            dataLine.push(element.gia_si_3);
          }
    
          if (isGrantPermission(permissions, ["newdanhmucsanpham.giakhachhang"])) {
            dataLine.push(element.gia_khach_hang);
            dataLine.push(element.gia_khach_hang_khuyen_mai);
          }
    
          dataLine.push(loaiSim.join(', '));
          dataLine.push(element.ghi_chu);
          dataLine.push(element.trang_thai == 'con_sim' ? 'Còn sim' : (element.trang_thai == 'giu_so' ? 'Giữ số' : 'Đã bán'));

          if (role.priority < 4) {
            dataLine.push(element.nguon_nhap);
          }

          data.push(dataLine)
          
          count++;
        })

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        const worksheet1 = XLSX.utils.aoa_to_sheet(data1);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách sim số');
        XLSX.utils.book_append_sheet(workbook, worksheet1, 'Từ khóa loại số');
        
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Danh-sach-sim-so-${(new Date()).toLocaleDateString("en-CA").replace(/_/g, "-")}.xlsx`);
      }

      dispatch(AppAction.appLoading(false))
    } catch (error) {
      if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
    }
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return '#000000';
  };

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <input
          ref={fileInput}
          type="file"
          onChange={(e) => handleImportFile(e)}
          style={{ display: 'none' }}
        />
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card">
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <PerfectScrollbar>
                <Box sx={{ maxWidth: '100%' }}>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ma"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.ma}
                    placeholder="Mã"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ten"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={values.ten}
                    placeholder="Tên"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                </Box>
              </PerfectScrollbar>
            </LocalizationProvider>
          </CardContent>
        </Card>
        <Card>
          <div className='functional-btn-container' style={{width: '250px', margin: 'auto'}}>
            {(role.priority < 4) && errorRows && Object.entries(errorRows).length > 0 && <Button
              color="primary"
              variant="contained"
              onClick={handleClickOpenErrorDialog}
              style={{ height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginRight: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              <ReportProblem style={{ color: "red" }} />
            </Button>}
            {(role.priority < 4) && <Button
              color="primary"
              variant="contained"
              onClick={handleClickOpen}
              style={{ height: '20px', padding: 0, marginTop: 0, width: "150px", minWidth: '20px', marginLeft: '0', backgroundColor: 'orange', fontWeight: 'normal' }}
              >
              Tạo bản ghi
            </Button>}
            {/* {(role.priority < 4) && <Button
              color="primary"
              variant="contained"
              onClick={() => window.open('https://docs.google.com/spreadsheets/d/1_i0226irnLKy8JhVjd4sTkCPCJKiAo82', '_blank', 'width=800,height=600')}
              style={{ height: '20px', padding: 0, marginTop: 0, width: "150px", minWidth: '20px', marginLeft: '5px', backgroundColor: 'orange', fontWeight: 'normal' }}
              >
              Form mẫu
            </Button>}
            {(role.priority < 4) && <Button
              color="primary"
              variant="contained"
              onClick={() => fileInput.current.click()}
              style={{ height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              <Upload style={{ color: "#2ecc71" }} />
            </Button>}
            <Button
              color="primary"
              variant="contained"
              onClick={() => exportExcel()}
              style={{ height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              <Download style={{ color: "#3498db" }} />
            </Button> */}
            <Button
              color="primary"
              variant="contained"
              onClick={onLookup}
              style={{ background: !isLoading ? 'transparent' : 'url(/static/images/loading.gif) no-repeat center center / contain', height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              {!isLoading ? <Cached style={{ color: "#3498db" }} /> : ''}
            </Button>
          </div>
        </Card>
      </Box>
      <CreateEditDialog open={open} handleClose={handleClose} type={"CREATE"} />
      <ErrorDialog open={openErrorDialog} handleClose={handleCloseErrorDialog} type={"CREATE"} />
    </Box>
  )
};

export default NewdanhmucsanphamToolbar;
